import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopOffDuty(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} popSize="xs" type="com_input">
      <h2 className="pop_tit">공휴일 당직 쉬는날 지정하기</h2>
      <div className="content_container scroll mb_no">
        <ul className="com_input_sec">
          <li className="input_field">
            <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
          </li>
          <li className="input_field">
            <div className="check center">
              <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
              <label htmlFor="rdo01">공휴일</label>
              <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
              <label htmlFor="rdo02">당직 쉬는날</label>
            </div>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">저장</button>
      </div>
    </Modal>
  );
}

export default PopOffDuty;
